import type { StateCreator } from 'zustand';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const createStore = <T>(store: StateCreator<T>, actionName: string) =>
  create<T>()(
    devtools(store, {
      anonymousActionType: actionName,
      enabled: import.meta.env.NODE_ENV === 'development',
    }),
  );
